module.exports = __webpack_public_path__ + "/images/grey-warning-31x26.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/grey-warning-31x26.png
// module id = 620
// module chunks = 0